import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
type Props = {
  title: string;
  description?: string;
};
export const QuickSearchUnavailability = ({ title, description }: Props) => {
  return (
    <div className="flex flex-col items-center" data-testid="QuickSearchUnavailability">
      <div className="QuickSearchUnavailability-header flex w-full items-center p-25 md:py-50">
        <div className="mr-40">
          <Icon
            className="shrink self-start text-orange"
            name={ICONS.WARNING}
            width="3rem"
            hasRtl
          />
        </div>
        <h1 className="m-0 text-20 text-black lg:text-24">{title}</h1>
      </div>
      {description != null && (
        <p className="QuickSearchUnavailability-descriptions m-0 w-full px-25 text-12">
          {description}
        </p>
      )}
    </div>
  );
};
